module.exports = __webpack_public_path__ + "static/media/main-title.9bbb57ba.svg";